module.exports = __webpack_public_path__ + "img/likeTitle.8530583b.png";